var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.67 69.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 28"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.84,
    cy: 34.84,
    r: 33.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.61 34.08a7 7 0 0 0 2 .62 6.4 6.4 0 0 0 1.31.11h0a8 8 0 0 0 1.3-.14 8 8 0 0 0 1.95-.62 7.58 7.58 0 0 0 3.94-4.56 7.4 7.4 0 0 0 .32-2.24 7.54 7.54 0 1 0-15.07 0 7.9 7.9 0 0 0 .33 2.26 7.6 7.6 0 0 0 3.92 4.57m20.76 29V50.45a9.84 9.84 0 0 0-9.69-9.76H26.9a9.62 9.62 0 0 0-9.32 7.55c-.08.37-.15 7.47-.2 14.33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/myProfile.f7b0bd50db9a12e3dfbbc8850714252d.svg";
export { ForwardRef as ReactComponent };